import { CircleCheckBig } from "lucide-react";
import { Reveal } from "./shared";
import { scrollToId } from "@/App";

export const Hero = () => (
  <section className="relative overflow-hidden px-4 pb-20 pt-16 sm:px-6 sm:pt-24 lg:px-8" data-testid="hero-section">
    <div className="mx-auto max-w-7xl">
      <div className="grid items-center gap-12 lg:grid-cols-[1.05fr_0.95fr] lg:gap-14">
        <div className="max-w-2xl">
          <Reveal>
            <div className="mb-6 inline-flex items-center rounded-full border border-[#E7E3D9] bg-white px-4 py-1.5 shadow-sm">
              <span className="mr-2 h-2 w-2 rounded-full bg-[#F97316]" />
              <span className="text-sm font-medium text-[#5F6E63]">Doctor-led training, on-site across the UK</span>
            </div>
            <h1 className="font-display text-4xl font-extrabold tracking-tight text-[#14231B] sm:text-5xl lg:text-6xl" data-testid="hero-headline">
              Give your workforce the <span className="text-[#1E7B4F]">confidence</span> to save a life.
            </h1>
            <p className="mt-6 text-lg leading-relaxed text-[#5F6E63]">
              Desk to Defib brings hands-on CPR, defibrillator and choking training directly to your
              office. One-hour sessions, led by doctors — empowering your people with the
              skills and confidence to respond when every second counts.
            </p>
            <div className="mt-8 flex flex-wrap items-center gap-4">
              <button
                data-testid="hero-book-btn"
                onClick={() => scrollToId("book")}
                className="inline-flex items-center justify-center rounded-full bg-[#1E7B4F] px-7 py-3.5 text-base font-semibold text-white shadow-md hover:bg-[#16603D] transition-colors duration-300"
              >
                Book a training session
              </button>
              <button
                data-testid="hero-pricing-btn"
                onClick={() => scrollToId("pricing")}
                className="inline-flex items-center justify-center rounded-full border border-[#E7E3D9] bg-white px-7 py-3.5 text-base font-semibold text-[#14231B] hover:bg-[#EFEDE6] transition-colors duration-300"
              >
                See pricing
              </button>
            </div>
            <div className="mt-10 flex flex-wrap lg:flex-nowrap items-center gap-x-5 gap-y-3 text-[13px] text-[#5F6E63]">
              {["Doctor-led sessions", "Real AED & manikin practice", "Hands-on, practical sessions"].map((t) => (
                <span key={t} className="flex items-center gap-2">
                  <CircleCheckBig className="h-5 w-5 text-[#1E7B4F]" />
                  {t}
                </span>
              ))}
            </div>
          </Reveal>
        </div>
        <Reveal delay={0.15} className="relative">
          <div className="absolute -top-8 -right-8 h-64 w-64 rounded-full bg-[#F97316]/10 blur-3xl" />
          <div className="absolute -bottom-8 -left-8 h-64 w-64 rounded-full bg-[#1E7B4F]/10 blur-3xl" />
          <div className="relative overflow-hidden rounded-3xl border border-[#E7E3D9] bg-white shadow-xl">
            <video
              src="/videos/hero.mp4"
              poster="/images/hero-cpr.webp"
              autoPlay
              muted
              loop
              playsInline
              className="h-auto w-full object-cover"
              data-testid="hero-video"
            />
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
